import React from 'react';
import { NewSummaryDetailsCard } from '../NewSummaryDetailsCard/NewSummaryDetailsCard';
import classNames from 'classnames';

export const PotentialSavingsCard = ({ title, details = [], className = '', ...props }) => {
    return (
        <NewSummaryDetailsCard
            className={classNames(className, 'potential-savings-card')}
            title={title}
            details={details}
            // headerRight="3-Year Savings"
            {...props}
        />
    );
};
